import React from 'react';
import Icon from '../openplay/OpenPlayIcon';

const DEFAULT_ITEMS = [
  { value: 'open_game', label: '오픈게임' },
  { value: 'lesson', label: '레슨' },
];

const CreateEventMenu = ({
  isOpen,
  items = DEFAULT_ITEMS,
  onSelect,
  onClose,
  className,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-[8999]" onClick={onClose} />
      <div className={(className || 'absolute bottom-full right-0 mb-3 w-[220px]') + ' z-[9000] relative'}>
        <div className="rounded-2xl border border-border bg-card shadow-elevation-4 overflow-hidden">
          <div className="p-2 space-y-1">
            {items.map((item) => (
              <button
                key={item.value}
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect?.(item.value);
                }}
                className="w-full flex items-center justify-between rounded-xl px-3 py-2.5 text-sm font-semibold text-foreground hover:bg-muted transition-smooth"
              >
                <span>{item.label}</span>
                <Icon name="ChevronRightIcon" size={18} className="text-muted-foreground" />
              </button>
            ))}
          </div>
        </div>
        <div className="absolute -bottom-2 right-5 w-4 h-4 bg-card border-r border-b border-border rotate-45" />
      </div>
    </>
  );
};

export default CreateEventMenu;
